import { useEffect, useRef } from 'react';
import {
  NavigationStore,
  useNavigationStore,
} from '../navigation/useNavigationStore';
import { useLocation } from 'react-router-dom';

type UsePageHeaderParams = Pick<NavigationStore, 'title' | 'breadcrumb'>;

export const usePageHeader = ({ title, breadcrumb }: UsePageHeaderParams) => {
  const { pathname } = useLocation();
  const { setPageHeader } = useNavigationStore();

  const navigationStorePropsRef = useRef<UsePageHeaderParams>({
    title,
    breadcrumb,
  });

  navigationStorePropsRef.current = {
    title,
    breadcrumb,
  };

  useEffect(() => {
    setPageHeader(navigationStorePropsRef.current);
  }, [pathname]);

  useEffect(() => {
    return () => {
      setPageHeader({ title: undefined, breadcrumb: undefined });
    };
  }, []);
};
